/** Paths that show UI only — data is not persisted to DynamoDB yet. */
export const DEMO_ONLY_PATHS = new Set([]);

export function isDemoOnlyPath(pathname) {
  if (!pathname) return false;
  const base = pathname.split('/').slice(0, 3).join('/');
  return DEMO_ONLY_PATHS.has(base) || DEMO_ONLY_PATHS.has(pathname);
}
